export class UploadExcel {
  files?: any;
  segmentDetails!: string;
}
